<template>
    <div class="sidebar" data-color="dark-blue">
        <div class="logo">
            <a href="/dashboard" class="simple-text logo-mini">
                <img class="float-left w-100" src="../assets/mini-logo.png"/>
            </a>
            <a href="/dashboard" class="simple-text" style="font-size: 17px;">
                <b>Museo {{ adminText }}</b>
            </a>
            <span v-if="isSuperAdmin !== true" class="text-white small">
                <b>{{ subscriptionText }}</b>
                <img v-if="currentSubscription.includes('Bronze')" style="max-width: 30px;" src="../assets/bronze.png"/>
                <img v-else-if="currentSubscription.includes('Silver')" style="max-width: 30px;" src="../assets/silver.png"/>
                <img v-else-if="currentSubscription.includes('Gold')" style="max-width: 30px;" src="../assets/gold.png"/>
                <img v-else-if="currentSubscription.includes('Platinum')" style="max-width: 30px;" src="../assets/platinum.png"/>
            </span>
        </div>
        <div class="sidebar-wrapper" id="sidebar-wrapper">
            <ul class="nav">
                <li>
                    <a href="/dashboard" :class="path.includes('/dashboard') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons design_app"></i>
                        <p class="sidebar-option"><b>Dashboard</b></p>
                    </a>
                </li>
                <li v-if="isSuperAdmin !== true">
                    <a href="/edit-institute" :class="path.includes('/edit-institute') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons business_bank"></i>
                        <p class="sidebar-option"><b>Institute Profile</b></p>
                    </a>
                </li>
                <li>
                    <a href="/edit-user" :class="path.includes('/edit-user') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons business_badge"></i>
                        <p class="sidebar-option"><b>User Profile</b></p>
                    </a>
                </li>
                <li>
                    <a href="/listings" :class="path.includes('/listings') || path.includes('/edit-listing') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons design_palette"></i>
                        <p class="sidebar-option"><b>The Catalog</b></p>
                    </a>
                </li>
                <li>
                    <a href="/events" :class="path.includes('/events') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons ui-1_calendar-60"></i>
                        <p class="sidebar-option"><b>Events</b></p>
                    </a>
                </li>
                <li>
                    <a href="/reports" :class="path.includes('/reports') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons design_bullet-list-67"></i>
                        <p class="sidebar-option"><b>Reports</b></p>
                    </a>
                </li>

                <hr v-if="isSuperAdmin === true" class="white-seperator">

                <li v-if="isSuperAdmin === true">
                    <a href="/mediums" :class="path.includes('/mediums') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons media-1_album"></i>
                        <p class="sidebar-option"><b>Manage Mediums</b></p>
                    </a>
                </li>
                <li v-if="isSuperAdmin === true">
                    <a href="/institutes" :class="path.includes('/institutes') ? 'sidebar-active-option' : ''">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <p class="sidebar-option"><b>Manage Institutes</b></p>
                    </a>
                </li>
                <li v-if="isSuperAdmin === true">
                    <a href="/eras" :class="path.includes('/eras') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons travel_istanbul" aria-hidden="true"></i>
                        <p class="sidebar-option"><b>Manage Eras</b></p>
                    </a>
                </li>
                <li v-if="isSuperAdmin === true">
                    <a href="/artists" :class="path.includes('/artists') ? 'sidebar-active-option' : ''">
                        <i class="fa fa-paint-brush" aria-hidden="true"></i>
                        <p class="sidebar-option"><b>Manage Artists</b></p>
                    </a>
                </li>

                <hr v-if="isSuperAdmin === true" class="white-seperator">
                
                <li v-if="isSuperAdmin === true">
                    <a href="/members" :class="path.includes('members') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons emoticons_satisfied" aria-hidden="true"></i>
                        <p class="sidebar-option"><b>Manage Users</b></p>
                    </a>
                 </li>
                 <li v-if="isSuperAdmin === true">
                    <a href="/users" :class="path.includes('/users') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons shopping_credit-card"></i>
                        <p class="sidebar-option"><b>Manage Curators</b></p>
                    </a>
                </li>
                <li v-if="isSuperAdmin === true">
                    <a href="/admins" :class="path.includes('/admins') ? 'sidebar-active-option' : ''">
                        <i class="now-ui-icons education_agenda-bookmark" aria-hidden="true"></i>
                        <p class="sidebar-option"><b>Manage Admins</b></p>
                    </a>
                </li>
                <li v-if="isSuperAdmin === true">
                    <a href="/legal" :class="path.includes('/legal') ? 'sidebar-active-option' : ''">
                        <i class="fa fa-gavel" aria-hidden="true"></i>
                        <p class="sidebar-option"><b>Manage Legal</b></p>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import isSuperAdmin from '../services/jwt/isSuperAdmin';
    import Users from '../controllers/user.controller';

    export default {
        name: 'Sidebar',
        data: function() {
            return {
                isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin')),
                adminText: isSuperAdmin(localStorage.getItem('superAdmin')) === true ? 'Admin' : 'Curator',
                currentSubscription: 4,
                subscriptionImage: '',
                path: this.path = this.$route.path,
                subscriptionText: ""
            }
        },

        beforeMount: async function() {
            this.currentSubscription = await Users.getCurrentPlan();
            if (this.currentSubscription) {
                this.subscriptionText = this.currentSubscription.charAt(0).toUpperCase() + this.currentSubscription.slice(1);
            } else {
                this.subscriptionText = "Inactive";
            }
        }
    }
</script>